import * as types from './types';
import API from '../../utils/api';
import { setError } from './errors';
import { AGENT_SERVICE_ENDPOINT_URL, internalError } from '../../constants/defaultValues';

export const setUserAccount = user => ({
    type: types.GET_USER_ACCOUNT_SUCCESS,
    payload: user,
});

export const getUserAccount = () => async dispatch => {
    try {
        dispatch({
            type: types.GET_USER_ACCOUNT_REQUEST,
        });

        const response = await API.get(`${AGENT_SERVICE_ENDPOINT_URL}/accounts/profile`);

        const { item } = response.data;
        dispatch(setUserAccount(item));
        dispatch({
            type: types.CHANGE_BET_STAKE_LIMITS,
            payload: {
                sportMinimum: item.minBettingStakeAmount,
                eSportMinimum: item.minBettingStakeAmountForESport,
            },
        });

        return item;
    } catch (err) {
        const errors = err?.response?.data?.info?.errors;
        if (!errors) {
            dispatch(setError(internalError));
            return false;
        }
        dispatch(setError(errors[0]));
    }
};
